var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('va-list',{attrs:{"resource":"temporaryReplacements","filter":{
      replaced_user: _vm.item.username
    },"disable-query-string":"","disable-global-search":"","disable-create":"","disable-export":"","disable-persistent-filter":""}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-show":"","disable-edit":"","disable-clone":"","disable-delete":"","disable-select":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }